import(/* webpackMode: "eager", webpackExports: ["default"] */ "/src/src/app/(staitc-page)/guide-tips/choose-eyeglasses/page.client.tsx");
